export default __webpack_public_path__ + "6cfa65c63939188f33ef0e3a68d09306.woff";